import React, { useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Categories from '../components/Categories';
import HowItWorks from '../components/HowItWorks';
import FAQ from '../components/FAQ';
import Newsletter from '../components/Newsletter';
import DownloadApp from '../components/DownloadApp';
import Footer from '../components/Footer';
import PrivacyPolicy from '../components/PrivacyPolicy';

export default function LandingPage() {
  const [showPrivacy, setShowPrivacy] = useState(false);

  return (
    <div className="min-h-screen" data-testid="landing-page">
      <Header />
      <Hero />
      <About />
      <Categories />
      <HowItWorks />
      <FAQ />
      <Newsletter />
      <DownloadApp />
      <Footer onPrivacyClick={() => setShowPrivacy(true)} />
      {showPrivacy && <PrivacyPolicy onClose={() => setShowPrivacy(false)} />}
    </div>
  );
}
